const set = require('regenerate')();

set.addRange(0x1735, 0x1736).addRange(0x1740, 0x1753);
module.exports = set;